/* The limit meter under the composer: board O's caption, groove and fill. */

.meter {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: var(--space-0) var(--space-14px);
}

.caption {
  display: flex;
  gap: var(--space-2);
  justify-content: space-between;
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
}

.reset {
  font-weight: var(--fw-regular);
  color: var(--text-2);
}

.track {
  display: block;
  height: 6px;
  overflow: hidden;
  background: var(--bg);
  border-radius: var(--radius-bar);
  box-shadow: var(--shadow-buddy-meter);
}

.fill {
  display: block;
  height: 6px;
  background: var(--buddy-warn);
  border-radius: var(--radius-bar);
}

.fillFull {
  background: var(--danger);
}

.warn {
  color: var(--buddy-warn);
}
